module.exports = __webpack_public_path__ + "static/media/josh-paper-scissors.26bb1f87.png";